import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Column, Icon, Row, VideoModal } from '@pella/sash-framework';
import { initDataLayer } from '../../utilities/functions';
import { Image } from '../../';
import styles from './index.module.scss';
import { isValidArray } from '../../utilities/validations';

const ImageGrid = ({ data, className, ...other }) => {
	const [videoModal, setVideoModal] = useState(false);

	if (!data || (data && !data.grid)) return null;
	const gridType = data?.grid?.grid_type?.replace(/[^A-Z0-9]+/gi, '_');

	const showDuration = () => {
		if (isValidArray(data?.grid?.video) && data.grid.video[0].schema && data.grid.video[0].schema.duration) {
			const duration = data.grid.video[0].schema.duration;
			const splitDuration = duration.split('PT')[1].split('M');
			const minute = splitDuration[0];
			const seconds = splitDuration[1].split('S')[0];

			return (
				<p className={styles.imageGrid_VideoDuration}>
					{minute}:{seconds}
				</p>
			);
		} else {
			return null;
		}
	};

	return (
		<div
			className={`${className || ''}`}
			{...other}
		>
			<Row
				align='center'
				noGutters={true}
				reverse={data.copy && data.copy.position === 'Left'}
			>
				<Column
					xs={12}
					lg={data.has_copy ? 7 : 12}
					xl={data.has_copy ? 8 : 12}
					xxl={data.has_copy ? 9 : 12}
				>
					<div className={`${styles.imageGrid_Grid} ${styles[`imageGrid_${gridType}`]}`}>
						{data.grid.featured_image?.[0] && (
							<div>
								<Image
									data={data.grid.featured_image[0]}
									className={styles.imageGrid_Image}
								/>
							</div>
						)}

						{data.grid.standard_images?.[0] &&
							data.grid.standard_images.map((images, index) => (
								<div key={index}>
									<Image
										data={images}
										className={styles.imageGrid_Image}
									/>

									{index === 0 && data.grid.video?.[0] && (
										<>
											<button
												onClick={() => {
													setVideoModal(true);
													initDataLayer('videoplay');
												}}
												className={styles.imageGrid_VideoBtn}
											>
												<span className={styles.srOnly}>Watch the Video</span>
												<div className={styles.video_PlayIcon}>
													<Icon name='play_arrow' />
												</div>
												{showDuration()}
											</button>

											<VideoModal
												isOpen={videoModal}
												onClose={() => setVideoModal(false)}
												videoId={data.grid.video[0].video.video_id}
												title={data.grid.video[0].schema.heading}
												transcript={data.grid.video[0].transcript}
											/>
										</>
									)}
								</div>
							))}
					</div>
				</Column>

				{data.has_copy && (
					<Column
						xs={12}
						lg={5}
						xl={4}
						xxl={3}
					>
						<div className={`${styles.imageGrid_Content} ${data.copy.position === 'Left' ? styles.imageGrid_Content_reverse : ''}`}>
							{data.copy.subheading && <p className={styles.imageGrid_Subheading}>{data.copy.subheading}</p>}
							{data.copy.heading && <h3 className={styles.imageGrid_Title}>{data.copy.heading}</h3>}
							{data.copy.description && (
								<div
									dangerouslySetInnerHTML={{
										__html: data.copy.description,
									}}
								/>
							)}
						</div>
					</Column>
				)}
			</Row>
		</div>
	);
};

ImageGrid.propTypes = {
	data: PropTypes.object,
	layout: PropTypes.string,
	className: PropTypes.string,
};

export default ImageGrid;
